export const ANNOUNCEMENTS_TOGGLE = "ANNOUNCEMENTS";
export const CSV_IMPORT_TOGGLE = "CSV_IMPORT";
export const SENT_ANNOUNCEMENTS_TOGGLE = "SENT_ANNOUNCEMENTS";
export const SCHEDULED_ANNOUNCEMENTS_TOGGLE = "SCHEDULED_ANNOUNCEMENTS";
export const FORWARD_ANNOUNCEMENTS_TOGGLE = "FORWARD_ANNOUNCEMENTS";
export const IMPERSONATION_TOGGLE = "IMPERSONATION";
export const EDIT_CHANNEL_TOGGLE = "EDIT_CHANNEL";
export const CREATE_CHANNEL_WITH_AUDIENCE_TOGGLE =
  "CREATE_CHANNEL_WITH_AUDIENCE";
